/* eslint-disable */

export const MESSAGE_UNEXPECTED_ERROR = { __all__: ['Unexpected Error'] }
export const MESSAGE_PERMISSION_DENIED = { __all__: ['You do not have permission to perform this action'] }
export const MESSAGE_NOT_FOUND_ERROR = { __all__: ['Not found'] }
export const MESSAGE_TIMEOUT_ERROR = { __all__: ['Request timed out'] }
export const MESSAGE_BAD_REQUEST_ERROR = { __all__: ['Bad request'] }
export const MESSAGE_UNPROCESSABLE_ENTITY = { __all__: ['Unprocessable entity'] }

export const messages = {
  MESSAGE_UNEXPECTED_ERROR,
  MESSAGE_PERMISSION_DENIED,
  MESSAGE_NOT_FOUND_ERROR,
  MESSAGE_TIMEOUT_ERROR,
  MESSAGE_UNPROCESSABLE_ENTITY
}

export const links = {
  'using-commodity-codes': '/learn/categories/selling-across-borders-product-and-services-regulations-licensing-and-logistics/get-your-goods-into-the-destination-country/using-commodity-codes/'
}

export default {
  messages
}
